var React = require('react');

function IconClearInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Zm2.828 4.172c-.195-.196-.438-.27-.542-.165L7 6.293 4.714 4.007l-.04-.029c-.118-.058-.329.02-.502.194-.196.195-.27.438-.165.542L6.293 7 4.007 9.286l-.029.04c-.058.118.02.329.194.502.195.196.438.27.542.165L7 7.707l2.286 2.286.04.029c.118.058.329-.02.502-.194.196-.195.27-.438.165-.542L7.707 7l2.286-2.286.029-.04c.058-.118-.02-.329-.194-.502Z","fill":"currentColor","fillRule":"evenodd"}));
}

IconClearInline.defaultProps = {"width":"14","height":"14"};

module.exports = IconClearInline;

IconClearInline.default = IconClearInline;
